import * as yup from "yup"

export const createOrderValidationSchema = yup.object().shape({
    ord_type: yup.string().oneOf(["limit", "market"], "Выберите формат").required('Выберите формат'),
    price: yup.number()
        .when("ord_type", (ord_type: any, schema) => {
            console.log(ord_type)
            if (ord_type[0] === 'limit') {
                return schema
                .min(0.01, 'Минимальная цена - 0.01')
                .max(2, 'Максимальная цена - 2')
                .typeError('Укажите число')
                .required('Укажите число')
            }
            return schema
        }),
    quantity: yup.number().min(1, "Минимальное количество - 1").typeError('Укажите число').required('Укажите количество бонусов')
})